import types from "./types";

const INITIAL_STATE = {
	vendor_evaluation: null,
	vendor_evaluationError: null,
	vendor_evaluationLoading: false,

	//create
	createvendor_evaluation: null,
	createvendor_evaluationError: null,
	createvendor_evaluationLoading: false,

	//update
	updatevendor_evaluation: null,
	updatevendor_evaluationError: null,
	updatevendor_evaluationLoading: false,

	//delete
	deletevendor_evaluation: null,
	deletevendor_evaluationError: null,
	deletevendor_evaluationLoading: false,

	//single item

	singleItem: null,
};

const VendorEvaluationReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_VENDOR_EVALUATION_START:
			return {
				...state,
				vendor_evaluation: null,
				vendor_evaluationError: null,
				vendor_evaluationLoading: true,
			};
		case types.GET_VENDOR_EVALUATION_SUCCESS:
			return {
				...state,
				vendor_evaluation: action.payload,
				vendor_evaluationLoading: false,
			};
		case types.GET_VENDOR_EVALUATION_ERROR:
			return {
				...state,
				vendor_evaluationError: action.payload,
				vendor_evaluationLoading: false,
			};
		case types.GET_VENDOR_EVALUATION_RESET:
			return {
				...state,
				vendor_evaluationError: null,
				vendor_evaluationLoading: false,
			};
		//create

		case types.CREATE_VENDOR_EVALUATION_START:
			return {
				...state,
				createvendor_evaluation: null,
				createvendor_evaluationError: null,
				createvendor_evaluationLoading: true,
			};
		case types.CREATE_VENDOR_EVALUATION_SUCCESS:
			return {
				...state,
				createvendor_evaluation: action.payload,
				createvendor_evaluationLoading: false,
			};
		case types.CREATE_VENDOR_EVALUATION_ERROR:
			return {
				...state,
				createvendor_evaluationError: action.payload,
				createvendor_evaluationLoading: false,
			};
		case types.CREATE_VENDOR_EVALUATION_RESET:
			return {
				...state,
				createvendor_evaluationError: null,
				createvendor_evaluationLoading: false,
			};
		//delete

		case types.DELETE_VENDOR_EVALUATION_START:
			return {
				...state,
				deletevendor_evaluation: null,
				deletevendor_evaluationError: null,
				deletevendor_evaluationLoading: true,
			};
		case types.DELETE_VENDOR_EVALUATION_SUCCESS:
			return {
				...state,
				deletevendor_evaluation: action.payload,
				deletevendor_evaluationLoading: false,
			};
		case types.DELETE_VENDOR_EVALUATION_ERROR:
			return {
				...state,
				deletevendor_evaluationError: action.payload,
				deletevendor_evaluationLoading: false,
			};
		case types.DELETE_VENDOR_EVALUATION_RESET:
			return {
				...state,
				deletevendor_evaluation: null,
				deletevendor_evaluationError: null,
				deletevendor_evaluationLoading: false,
			};

		//update
		case types.UPDATE_VENDOR_EVALUATION_START:
			return {
				...state,
				updatevendor_evaluation: null,
				updatevendor_evaluationError: null,
				updatevendor_evaluationLoading: true,
			};
		case types.UPDATE_VENDOR_EVALUATION_SUCCESS:
			return {
				...state,
				updatevendor_evaluation: action.payload,
				updatevendor_evaluationLoading: false,
			};
		case types.UPDATE_VENDOR_EVALUATION_ERROR:
			return {
				...state,
				updatevendor_evaluationError: action.payload,
				updatevendor_evaluationLoading: false,
			};
		case types.UPDATE_VENDOR_EVALUATION_RESET:
			return {
				...state,
				updatevendor_evaluation: null,
				updatevendor_evaluationError: null,
				updatevendor_evaluationLoading: false,
			};
		//singleItem
		// case types.SINGLE_VENDOR_EVALUATION_START:
		// 	return {
		// 		...state,
		// 		updatevendor_evaluation: null,
		// 		updatevendor_evaluationError: null,
		// 		updatevendor_evaluationLoading: true,
		// 	};
		// case types.SINGLE_VENDOR_EVALUATION_SUCCESS:
		// 	return {
		// 		...state,
		// 		updatevendor_evaluation: action.payload,
		// 		updatevendor_evaluationLoading: false,
		// 	};
		// case types.SINGLE_VENDOR_EVALUATION_ERROR:
		// 	return {
		// 		...state,
		// 		updatevendor_evaluationError: action.payload,
		// 		updatevendor_evaluationLoading: false,
		// 	};
		// case types.SINGLE_VENDOR_EVALUATION_RESET:
		// 	return {
		// 		...state,
		// 		updatevendor_evaluationError: null,
		// 		updatevendor_evaluationLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default VendorEvaluationReducer;
